import { ILocalStorage } from '../../storage/interfaces';
import { StorageKeys } from '../../../utils/constants';
import { BehaviorSubject } from 'rxjs';
import { IPreferencesService } from './types';

class PreferencesService<T> implements IPreferencesService<T> {
  onPreferencesChanged: BehaviorSubject<T>;

  constructor(private persistentStorage: ILocalStorage, defaultPreferences: T) {
    this.onPreferencesChanged = new BehaviorSubject<T>(defaultPreferences);
    const savedPreferences = this.persistentStorage.get(StorageKeys.PREFERENCES);
    if (!savedPreferences) return;
    const prevPreferences = this.onPreferencesChanged.value;
    const newPreferences = Object.assign(prevPreferences, savedPreferences);
    this.onPreferencesChanged.next(newPreferences);
  }

  updatePreferences(key: keyof T, value: boolean | string) {
    const prevPreferences = this.onPreferencesChanged.value;
    const newPreferences = { ...prevPreferences, [key]: value };
    this.persistentStorage.set(StorageKeys.PREFERENCES, newPreferences);
    this.onPreferencesChanged.next(newPreferences);
  }

  getPreferences(key: keyof T) {
    return this.onPreferencesChanged.value[key];
  }
}

export default PreferencesService;
